import React from 'react';
import ConfidenceIndicator from './ConfidenceIndicator';
import PriorityFlag from './PriorityFlag';
interface ThemeCardProps {
  title: string;
  count: number;
  description: string;
  priority: 'low' | 'medium' | 'high' | 'critical';
  confidence: number;
  treatyRelevant?: boolean;
}
const ThemeCard: React.FC<ThemeCardProps> = ({
  title,
  count,
  description,
  priority,
  confidence,
  treatyRelevant = false
}) => {
  return <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-122">
      <div className="p-5" data-id="element-123">
        <div className="flex justify-between items-start" data-id="element-124">
          <div data-id="element-125">
            <h3 className="text-lg font-medium text-gray-900" data-id="element-126">{title}</h3>
            <p className="text-sm text-gray-500 mt-1" data-id="element-127">{count} submissions</p>
          </div>
          <div className="flex space-x-2" data-id="element-128">
            <PriorityFlag level={priority} data-id="element-129" />
            {treatyRelevant && <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-130">
                Treaty
              </span>}
          </div>
        </div>
        <p className="mt-3 text-sm text-gray-600" data-id="element-131">{description}</p>
        <div className="mt-4 flex justify-between items-center" data-id="element-132">
          <ConfidenceIndicator score={confidence} data-id="element-133" />
          <button className="text-sm text-blue-600 hover:text-blue-500 font-medium" data-id="element-134">
            View details
          </button>
        </div>
      </div>
    </div>;
};
export default ThemeCard;